import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomDivider from '../../../v2-components/Antd/Divider';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomModal from '../../../v2-components/Antd/Modal';
import CustomSwitch from '../../../v2-components/Antd/Switch';
import useLandingPharmacyStore from '../store/useLandingPharmacyStore';
import { Service } from './service';
import './style.scss';
import Loading from '../../../v2-components/Loading';

export default function UserLandingPage() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [platform, currentPage, status, mainData, setPlatform, setCurrentPage, setStatus, setPageData, setMainData] = useLandingPharmacyStore((state) => [
		state.platform,
		state.currentPage,
		state.status,
		state.mainData,
		state.setPlatform,
		state.setCurrentPage,
		state.setStatus,
		state.setPageData,
		state.setMainData,
	]);

	const user = JSON.parse(localStorage.getItem('userInfo'));

	useEffect(() => {
	if (user && user.pharmacy) {
		setPlatform(user.pharmacy);
	}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const history = useHistory();
	useEffect(() => {
		if (platform) {
			setLoading(true);
			new Service()
				.getPages(platform, currentPage, 'landing')
				.then((response) => {
					if (!currentPage) {
						setStatus(response?.page1?.length > 0 ? response.page1[0].isPageActive : false, 'page1');
						setStatus(response?.page2?.length > 0 ? response.page2[0].isPageActive : false, 'page2');
						setStatus(response?.page3?.length > 0 ? response.page3[0].isPageActive : false, 'page3');
						setMainData(response);
						setLoading(false);
					} else {
						setPageData(response);
						setLoading(false);
					}
				})
				.catch((error) => {
					console.log('Error', error);
				});
		}
	}, [platform, currentPage, setStatus, setPageData, setMainData]);

	const handlePageChange = (page) => {
		setCurrentPage(page);
		setIsModalOpen(true);
	};

	const handleSwitchChange = (page, status) => {
		const body = {
			country: Enviroment.COUNTRY,
			root_pharmacy: platform,
			page: page,
			isPageActive: status,
			section: 'landing',
		};
		new Service()
			.updateIsPageActive(body)
			.then((response) => {
				setStatus(response.isPageActive, `page${response.page}`);
			})
			.catch((error) => console.log('error', error));
	};

	return (
		<>
			<div className="admin-landing-page">
				<h1>Configuración de páginas promocionales</h1>
				{loading && <Loading />}
				{platform && !loading && (
					<>
						<h2>Seleccionar página a editar</h2>
						<Row gutter={[16, 16]}>
							<Col md={8} xs={24}>
								<CustomCard
									onClick={() => handlePageChange('1')}
									className="landing-cards"
									title={
										<div className="landing-card-header-container">
											<h3>Página promocional 1</h3>
											<div className="inner-container">
												<p>Hasta 8 secciones con 3 elementos</p>
												<p>configurables</p>
											</div>
										</div>
									}
								>
									<CustomImage
										preview={false}
										src={'https://storage.googleapis.com/tirx-resources-develop/d6f3ea1b-7549-484a-b2e3-7b15db0963d3.webp'}
										alt="img"
									/>
								</CustomCard>
								<CustomSwitch
									disabled={mainData?.page1?.length < 1 || !mainData?.page1[0]?.tag}
									className={'switch'}
									checked={status.page1}
									onChange={(e) => {
										handleSwitchChange(1, e);
									}}
								/>
							</Col>
							<Col md={8} xs={24}>
								<CustomCard
									onClick={() => handlePageChange('2')}
									className="landing-cards"
									title={
										<div className="landing-card-header-container">
											<h3>Página promocional 2</h3>
											<div className="inner-container">
												<p>Hasta 8 secciones con 3 elementos</p>
												<p>configurables</p>
											</div>
										</div>
									}
								>
									<CustomImage
										preview={false}
										src={'https://storage.googleapis.com/tirx-resources-develop/0280f50f-4e10-49e5-a133-ed75c82feaf9.webp'}
										alt="img"
									/>
								</CustomCard>
								<CustomSwitch
									disabled={mainData?.page2?.length < 1 || !mainData?.page2[0]?.tag}
									className={'switch'}
									checked={status.page2}
									onChange={(e) => {
										handleSwitchChange(2, e);
									}}
								/>
							</Col>
							<Col md={8} xs={24}>
								<CustomCard
									onClick={() => handlePageChange('3')}
									className="landing-cards"
									title={
										<div className="landing-card-header-container">
											<h3>Página promocional 3</h3>
											<div className="inner-container">
												<p>Hasta 8 secciones con 3 elementos</p>
												<p>configurables</p>
											</div>
										</div>
									}
								>
									<CustomImage
										preview={false}
										src={'https://storage.googleapis.com/tirx-resources-develop/f5af2207-be73-4f12-99e1-203e5993dd86.webp'}
										alt="img"
									/>
								</CustomCard>
								<CustomSwitch
									disabled={mainData?.page3?.length < 1 || !mainData?.page3[0]?.tag}
									className={'switch'}
									checked={status.page3}
									onChange={(e) => {
										handleSwitchChange(3, e);
									}}
								/>
							</Col>
						</Row>
					</>
				)}
				<CustomModal
					title="Página complementaria"
					open={isModalOpen}
					centered
					onCancel={() => setIsModalOpen(false)}
					footer={[
						<CustomButton
							key="ok"
							type="primary"
							onClick={() => {
								setIsModalOpen(false);
								history.push('/user-landing/detail');
							}}
						>
							Continuar
						</CustomButton>,
					]}
				>
					<CustomDivider />
					<p>
						Este tipo de página permite habilitar listas de productos y espacios publicitarios para acciones de marketing como "Cyber
						Monday" y el "Día de la madre". <br />
						Posee un link de acceso en el encabezado de la web para mayor impacto
					</p>
					<CustomImage
						preview={false}
						src={'https://storage.googleapis.com/tirx-resources-develop/45af7e4b-3b5e-4e5d-a25e-67479d7a9cbb.webp'}
						alt="img"
					/>
				</CustomModal>
			</div>
		</>
	);
}
